<template>
  <div>
    <div>
        <div class="WorkM_ApprovalConditionArea px-0 py-2 d-flex" style="display: flex; flex-wrap:wrap;">
          <b-button-group class="d-flex text-center align-middle" size="sm">
            <b-button class="px-1" variant="outline-success" @click="approvalAllRows">全承認</b-button>
            <label class="spacer"></label>
            <b-button class="px-1" variant="outline-danger" @click="rejectionAllRows">全否認</b-button>
            <label class="spacer"></label>
            <b-button class="px-1" variant="outline-secondary" @click="uncheckAllRows">選択解除</b-button>
          </b-button-group>
          <div v-if="approvalList.length > 0" class="d-flex align-items-center">（ 全 {{ approvalList.length }} 件 ）</div>
        </div>
        <!-- 一覧 -->
        <div class="WorkM_ApprovalApplicationListArea">
          <div v-if="!listEmptyCheck(approvalList)" class="mt-3">
            <div  v-for="approvalItem in approvalList" :key="approvalItem.slipNo">
              <div class="WorkM_ApprovalApplicationItem">
                <div class="WorkM_ApprovalApplicationItem_HeaderArea">
                    <div 
                    v-if="!emptyCheck(approvalItem.applicationKbn)"
                    class="SegmentLabel"
                    :class="[
                      { WorkInfoItem_WorkTimeArea_Red: !isAttendanceCheck(approvalItem.applicationKbn)},
                    ]"
                    >
                      {{ getDispSegment(approvalItem.applicationKbn) }}
                    </div>
                    <div class="ApprovalApplicationSelectArea">
                      <div class="ApprovalLabel" style="color:rgb(20,78,34)">
                        <b-form-checkbox size="sm" v-model="approvalItem.approvalKbn" value=1 unchecked-value="0" @change="applicationCount">
                          承認
                        </b-form-checkbox>
                      </div>
                      <div class="RejectionLabel" style="color:red;">
                        <b-form-checkbox size="sm" v-model="approvalItem.approvalKbn" value=9 unchecked-value="0" @change="applicationCount">
                          否認
                        </b-form-checkbox>
                      </div>
                    </div>
                </div>
                <div class="WorkM_ApprovalApplicationItem_DetailArea" @click="openApplicationEditModal(2, approvalItem)" style="cursor: pointer;">
                  <div style="margin-bottom:5px">
                    <div class="ApprovalDetailItem">
                      <div class="ApprovalDate" style="height: 25px;">
                        <div v-if="!emptyCheck(approvalItem.shainName)" class="mr-3 d-flex align-items-center" style="white-space: nowrap;">{{ "" + approvalItem.shainName + ""}}</div>
                      </div>
                      <div class="ApprovalDetailItem ApprovalDetailItemApprovalApplication">
                        <div v-if="!emptyCheck(approvalItem.departmentName) && !emptyCheck(approvalItem.sectionName)" class="mr-2 d-flex align-items-center ApprovalDetailItemConstruction">
                          {{ "" + approvalItem.departmentName + " " + approvalItem.sectionName + ""}}
                        </div>
                      </div>
                    </div>
                    <div class="ApprovalDate ApprovalDateApprovalApplication">
                      <div 
                      v-if="!emptyCheck(approvalItem.applicationTargetDate)" 
                      class="mr-2 d-flex align-items-center"
                      style="min-width:110px;"
                      >
                        {{ "" + approvalItem.applicationTargetDate + "" }}
                      </div>
                      <div 
                      v-if="!emptyCheck(approvalItem.applicationTargetStartTime) && !emptyCheck(approvalItem.applicationTargetEndTime)" 
                      class="d-flex align-items-center" 
                      style="min-width:125px;">
                        {{ approvalItem.applicationTargetStartTime + "～" + approvalItem.applicationTargetEndTime }}
                      </div>
                    </div>
                  </div>
                  <!---->
                  <div class="ApprovalDetailItem mt-1">
                    <div>
                      <div class="d-flex">
                        <div v-if="approvalItem.constructionCode > 0" class="mr-2">{{ "[" + approvalItem.constructionCode + "]" }}</div>
                        <div v-if="approvalItem.disasterKbn > 0" class="text-danger">災害</div>
                      </div>
                      <div v-if="!emptyCheck(approvalItem.constructionName)">{{ approvalItem.constructionName }}</div>
                    </div>
                  </div>
                  <div class="ApprovalDetailItem">
                    <div v-if="!emptyCheck(approvalItem.applicationReason)">
                      <div class="DispReasonArea" v-html="setLineFeedCode(approvalItem.applicationReason)"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="mt-3 mb-1 border rounded-sm explainArea">
            <div>
              <label class="mb-0">承認対象の事前申請はありません。</label>
            </div>
          </div>
        </div>
        <!---->
        <div class="d-flex justify-content-between fixed-bottom px-3 ApprovalFooter">
          <div class="d-flex my-2 mx-auto">
            <div class="WorkM_WorkRegistButtonArea">
              <b-button :disabled="listEmptyCheck(approvalList)" class="WorkM_Button btn-secondary px-5" @click="sendWorkMail">確定</b-button>
            </div>
          </div>
          <div class="my-1" style="position:absolute;right:10px;background-color: transparent;">
            <div class="mx-1" style="font-size: 0.85rem">承認 {{countApproval}}件</div>
            <div class="mx-1" style="font-size: 0.85rem">否認 {{countRejection}}件</div>
          </div>
        </div>

    </div>
    <ApplicationEditModal 
    ref="ApplicationEditModal"
    :clickType="this.clickType"
    :selectApplication="this.selectApplication"
    ></ApplicationEditModal>
  </div>
</template>
<script>
import config from "../../const/config"
import ApplicationEditModal from "../Modal/ApplicationEditModal.vue";
export default {
  name: "ApprovalApplication",
  components: { ApplicationEditModal },
  data() {
    return {
      clickType: 2,
      selectApplication: {},
      approvalList:[
      ],
      countApproval: 0,
      countRejection: 0,
      countNonApproval: 0,
    };
  },
  computed: {},
  watch: {},
  mounted: function () {
    this.systemVersion = this.$store.getters.getSystemVersion;
    this.loginUserId = this.$store.state.user_id;
  },

  methods: {
     // 押下した箇所に合わせて、開くモーダルのタイトルを変更する
    // clickType:2 事前申請承認詳細画面
    openApplicationEditModal: function (clickType, approvalItem) {
      console.debug("approvalItem：" + JSON.stringify(approvalItem));
      this.getApprovalApplicationInfoDetailAPI(approvalItem);
    },
    getDispSegment: function (segmentCd) {
      let optionSegment = config.OPTIONS.APPLICATION_SEGMENT_SIMPLE;
      let result = "";
      optionSegment.forEach((element) => {
        if (element.value == segmentCd) {
          result = element.text;
        }
      });
      this.applicationCount();
      return result;
    },
    // 申請承認情報を取得する
    getApprovalApplicationInfo: function(){
      console.log("call getApprovalApplicationInfo");
      this.getApprovalApplicationInfoAPI();
    },
    // APIから申請承認情報を取得する
    getApprovalApplicationInfoAPI: function(){
      let paramList = {
          shainCd: this.loginUserId,
      };
      console.debug("paramList：" + JSON.stringify(paramList));
      this.getWithParams(config.URL.APPROVAL_REGIST_APPLICATION, paramList)
        .then((response) => {
          if(response.result){
            console.debug("response：" + JSON.stringify(response.container));
            this.setApprovalApplicationInfo(response.container);
          }
          else{
            this.showAlertErrorHTML(response.message);
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {
          this.applicationCount();
        });
    },
    // 取得した情報を変数にセットする
    setApprovalApplicationInfo: function(item){
      this.approvalList = item.applicationInfoList;
    },

    // APIから申請詳細情報の取得
    getApprovalApplicationInfoDetailAPI: function(approvalItem){
      let paramList = {
          shainCd: approvalItem.shainCd,
          targetDate: approvalItem.applicationTargetDate,
          applicationKbn: approvalItem.approvalKbn,
          applicationDenno: approvalItem.slipNo,
      }
      console.debug(JSON.stringify(paramList));
      this.getWithParams(config.URL.APPLICATION_REGIST+"/slipno", paramList)
        .then((response) => {
          if(response.result){
            console.debug("response：" + JSON.stringify(response.container));
            this.isErrorGetShfitFlg = false;
            this.setApplicationRegistInfo(response.container);
            console.log("selectApplication：" + JSON.stringify(this.selectApplication));
            this.$refs.ApplicationEditModal.openModal();
          }
          else{
            this.isErrorGetShfitFlg = true;
            this.showAlertError(response.message);
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
    },

    setApplicationRegistInfo: function(items){
      this.clickType = 2;
      this.selectApplication = {
        shiftStart: items.shiftStart, // シフト開始時刻
        shiftEnd: items.shiftEnd, // シフト終了時刻
        targetDateInfo: items.targetDateInfo,
        applicationInfoList: items.applicationInfoList[0],
        applicationRemainInfo: items.applicationRemainInfo,
      };
    },

    // 全承認機能
    approvalAllRows: function(){
      if(this.listEmptyCheck(this.approvalList)){
        return;
      }
      this.approvalList.forEach((element) => {
        element.approvalKbn = 1;
      });
      this.applicationCount();
    },
    // 全否認機能
    rejectionAllRows: function(){
      if(this.listEmptyCheck(this.approvalList)){
        return;
      }
      this.approvalList.forEach((element) => {
        element.approvalKbn = 9;
      });
      this.applicationCount();
    },
    // 選択解除機能
    uncheckAllRows: function(){
      if(this.listEmptyCheck(this.approvalList)){
        return;
      }
      this.approvalList.forEach((element) => {
        element.approvalKbn = 0;
      });
      this.applicationCount();
    },
    // 承認・否認件数チェック
    applicationCount: function(){
      console.log("call applicationCount");
      let countApproval = this.approvalList.filter((value) => {
        return value.approvalKbn == 1;
      });
      let countRejection = this.approvalList.filter((value) => {
        return value.approvalKbn == 9;
      });
      let countNonApproval = this.approvalList.filter((value) => {
        return value.approvalKbn != 1 && value.approvalKbn != 9;
      });
      this.countApproval = countApproval.length;
      this.countRejection = countRejection.length;
      this.countNonApproval = countNonApproval.length;
    },
    // 出勤しているかチェックする
    // true：出勤
    // false：休み
    isAttendanceCheck: function(workSegment){
      const WORK_SEGMENT_EARLY_START = 1; // 早出
      const WORK_SEGMENT_OVERTIME = 2; // 残業
      const WORK_SEGMENT_HOLIDAY_TRANSFER = 11; // 休日出勤（振替）
      const WORK_SEGMENT_HOLIDAY_ALLOWANCE = 12; // 休日出勤（残業）
      const WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER = 21; // 公休出勤（振替）
      const WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE = 22; // 公休出勤（残業）
      
      if(workSegment != WORK_SEGMENT_EARLY_START
      && workSegment != WORK_SEGMENT_OVERTIME 
      && workSegment != WORK_SEGMENT_HOLIDAY_TRANSFER 
      && workSegment != WORK_SEGMENT_HOLIDAY_ALLOWANCE 
      && workSegment != WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER 
      && workSegment != WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE 
      && workSegment > 0){
        return false;
      }
      else{
        return true;
      }
    },

    // 確定処理
    sendWorkMail: function(){
      if(this.countApproval <= 0 && this.countRejection <= 0){
        this.showAlertErrorHTML("承認・否認する申請を選択してください。", "確認");
        return;
      }

      // 承認結果が承認、または否認の項目を抽出
      let countApproval = this.approvalList.filter((value) => {
        return value.approvalKbn == 1 || value.approvalKbn == 9;
      });

      // 登録する内容一覧を生成
      let userId = this.loginUserId;
      let registList = [];
      countApproval.forEach(function(approval){
        let registItem = {
          applicationTargetDate:approval.applicationTargetDate,
          applicationShainCd:approval.shainCd,
          applicationDetailNo:approval.slipNo,
          approvalKbn:approval.approvalKbn,
          approvalShainCd:userId,
        }
        registList.push(registItem);
      });

      // 送信前のパラメータ設定
      let json = {
        approvalList: registList,
      };
      console.log("json：" + JSON.stringify(json));

      // 確認メッセージ
      let message = "以下の内容で承認を確定します。"
      + "<br>・承認：" + this.countApproval + " 件"
      + "<br>・否認：" + this.countRejection + " 件"
      if(this.countNonApproval > 0){
        message = message + "<br> <label style='color:red;'>＊未設定が " + this.countNonApproval + " 件あります。</label>";
      }
      message = message + "<br>よろしいですか？";
      this.$confirm(message, "確認", {
        confirmButtonText: "OK",
        cancelButtonText: "キャンセル",
        dangerouslyUseHTMLString: true,
        customClass:"editCheckModalWidthHeader"
      }).then(() => {
        // 新規登録
        this.postData(config.URL.APPROVAL_REGIST_APPLICATION, json)
          .then((response) => {
            console.debug("response：" + JSON.stringify(response));
            // レスポンスの結果がfalseならエラーメッセージを表示
            if(!response.result){
              this.showAlertErrorHTML(response.message);
              return;
            }
          })
          .catch((e) => {
            // Note: エラーメッセージは、共通処理で表示している
            console.error(e);
          })
          .finally(() => {
            this.getApprovalApplicationInfo();
            this.$emit("getApprovalCount");
          });
      });
    },
    // 空文字かチェック
    // true: 空文字
    // false: 空文字ではない
    emptyCheck(text){
      if(text != null && text != ""){
        return false;
      }
      else{
        return true;
      }
    },
    // リストからチェック
    // true：空
    // false：空ではない
    listEmptyCheck: function(list){
      if(list != null && list.length > 0){
        return false;
      }
      else{
        return true;
      }
    },
    // 事由 改行コードを<br>にする
    setLineFeedCode: function(msg){
      let newMsg = msg?.replace(/\n/g,'<br>');
      return newMsg;
    }
  },
};
</script>
<style>
.ApprovalDetailItemApprovalApplication{
  font-weight: 400; 
  flex-wrap:wrap; 
  font-size:0.85rem;
}
.WorkM_ApprovalConditionArea {
  border-bottom: 1px solid rgb(212, 212, 212);
}

.WorkM_ApplicationHeader {
  display: flex;
  justify-content: center;
  padding: 1rem;
  font-size: 1.2rem;
}
.ConditionStartDate {
  width: 280px;
}

.WorkM_ApprovalApplicationListArea {
  height: 100%;
}

.WorkM_ApprovalApplicationItem {
  display: flex;
  margin-bottom: 0.7rem;
  background: rgb(227, 227, 227);
  box-shadow: 2px 2px 3px rgb(230, 230, 230);
  border-radius: 5px;
  height: 100%;
}
.WorkM_ApprovalApplicationItem_HeaderArea {
  font-size: 0.9rem;
  height: 100%;
  min-width: 5rem;
}
.SegmentLabel {
  padding: 4px;
  width: 100%;
  background: rgb(24, 103, 194);
  color: rgb(255, 255, 255);
  font-weight: 700;
  border-radius: 5px 0 0 0;
  min-width: 4rem;
  text-align: center;
}

.ApprovalApplicationSelectArea {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.ApprovalApplicationSelectArea .ApprovalLabel {
  padding-left: 0.5rem;
  text-align: left;
}
.ApprovalApplicationSelectArea .RejectionLabel {
  padding-left: 0.5rem;
  text-align: left;
}

.WorkM_ApprovalApplicationItem_DetailArea {
  overflow:hidden;
  padding: 0.3rem 0.5rem;
  flex-grow: 1;
  background: #f5f5f5;
}
.WorkM_ApprovalApplicationItem_DetailArea .ApprovalDetailItem {
  display: flex;
  font-size: 0.95rem;
}
.WorkM_ApprovalApplicationItem_DetailArea .ApprovalDetailItem .DispReasonArea {
  word-break: break-all;
}
.WorkM_ApprovalApplicationItem_DetailArea .ApprovalDate {
  font-size: 1.1rem;
  display: flex;
  font-weight: 700;
}
.ApprovalCheckBox.custom-control-input{
  height:1rem !important;
}
.WorkM_ApprovalApplicationListArea .explainArea {
  font-size: 1rem; 
  padding: 0.25rem; 
  background-color: rgb(238, 238, 238);
}
</style>